import { prefix } from './prefix';

// 头像刷新事件名，其他模块在头像上传/裁剪成功后触发这个事件。
const AVATAR_REFRESH_EVENT = 'lx-user-avatar-refresh';

// 用时间戳作为缓存戳，拼到头像地址后面，强制浏览器重新拉取最新图片。
let avatarRefreshToken = 0;

/**
 * 主动通知全局头像需要刷新。
 * 常用于上传头像、裁剪头像、修改影响头像展示的信息后调用。
 *
 * @returns 本次刷新生成的缓存戳
 */
function refreshUserAvatar() {
  if (typeof window === 'undefined') {
    return 0;
  }

  // 每次刷新都更新缓存戳，并广播给监听头像的组件。
  avatarRefreshToken = Date.now();
  window.dispatchEvent(new CustomEvent(AVATAR_REFRESH_EVENT, {
    detail: avatarRefreshToken
  }));
  return avatarRefreshToken;
}

/**
 * 订阅头像刷新事件。
 * 一般由 NavBar 这类展示头像的组件调用，在收到事件后重新设置头像地址。
 *
 * @param callback 收到刷新通知后的回调，参数为最新缓存戳
 * @returns 取消订阅的方法
 */
function subscribeUserAvatarRefresh(callback) {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  // NavBar 之类的组件通过订阅这个事件，在收到通知后更新自己的头像地址。
  const handleRefresh = event => {
    const customEvent = event;
    callback(customEvent.detail || avatarRefreshToken);
  };
  window.addEventListener(AVATAR_REFRESH_EVENT, handleRefresh);
  return () => {
    window.removeEventListener(AVATAR_REFRESH_EVENT, handleRefresh);
  };
}

/**
 * 生成用户头像访问地址。
 * 会自动追加缓存戳，避免浏览器命中旧头像缓存。
 *
 * @param userId 用户 ID
 * @param token 可选缓存戳，不传时使用当前全局缓存戳
 * @returns 可直接用于 img src 的头像地址；没有 userId 时返回空字符串
 */
function getUserAvatarUrl(userId, token) {
  if (!userId) {
    return '';
  }

  // 给头像地址追加缓存戳，避免浏览器一直命中旧图片缓存。
  const cacheToken = token ?? avatarRefreshToken;
  const query = cacheToken ? `?t=${cacheToken}` : '';
  return `${prefix.iam}/photo/user/${userId}/photo.jpeg${query}`;
}
export { AVATAR_REFRESH_EVENT, getUserAvatarUrl, refreshUserAvatar, subscribeUserAvatarRefresh };